module.exports = __webpack_public_path__ + "fonts/Benzin-Medium.381eef9.woff";